import { SIDEBAR_MAX_SIZE_RATIO, SidebarSide } from '../../../pocos/sidebar.class';
import { SidebarComponent } from '../sidebar-component.class';

export class ResizeHandler {
    public isResizing = false;

    constructor(
        private sidebarRef: SidebarComponent,
        private index: number
    ) {}

    public initResizable() {
        let handles: string;
        switch (this.sidebarRef.currentSide) {
            case SidebarSide.Left:
                handles = 'e';
                break;
            case SidebarSide.Right:
                handles = 'w';
                break;
            case SidebarSide.Top:
                handles = 's';
                break;
            case SidebarSide.Bottom:
                handles = 'n';
                break;
            default:
                handles = 'e';
        }

        let sidebar = this.sidebarRef.getSidebarNode();
        let $sidebar = $(sidebar as HTMLElement);

        let self = this;
        $sidebar.resizable({
            handles: handles,
            minWidth: 150,
            maxWidth: $(window).width() * SIDEBAR_MAX_SIZE_RATIO,
            minHeight: 150,
            maxHeight: $(window).height() * SIDEBAR_MAX_SIZE_RATIO,
            disabled: !this.sidebarRef.isPanelOpen,
            start: function (event, ui) {
                self.isResizing = true;
                self.sidebarRef.getSidebarNode().dispatchEvent(new CustomEvent('resize:start', { detail: { index: self.index } }));
            },
            stop: function (event, ui) {
                if (self.sidebarRef.currentSide === SidebarSide.Left || self.sidebarRef.currentSide === SidebarSide.Right) {
                    self.sidebarRef.panelWidth = ui.size.width;
                    self.sidebarRef.getSidebarNode().dispatchEvent(
                        new CustomEvent('resize:changed', {
                            detail: ui.size.width,
                        })
                    );
                } else {
                    self.sidebarRef.panelHeight = ui.size.height;
                    self.sidebarRef.getSidebarNode().dispatchEvent(
                        new CustomEvent('resize:changed', {
                            detail: ui.size.height,
                        })
                    );
                }

                self.isResizing = false;
            },
        });
    }

    public updateResizable() {
        const sidebar = $(`#${SidebarComponent.SIDEBAR_ID}-${this.index}`);

        if (sidebar.data('ui-resizable')) {
            sidebar.resizable('destroy');
        }

        this.initResizable();
    }

    public setEnabled(enabled: boolean): void {
        let sidebar = $(this.sidebarRef.getSidebarNode());

        if (sidebar.data('ui-resizable')) {
            sidebar.resizable('option', 'disabled', !enabled);
        }
    }
}
